import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const Telegram = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.55403 13.5805L2.84918 12.1434C1.80415 11.8801 1.69329 10.4279 2.68606 10.0067L18.9874 3.09043C19.8056 2.7433 20.6805 3.44674 20.5262 4.32767L17.8667 19.5137C17.715 20.3801 16.6818 20.7468 16.0247 20.1674L8.55403 13.5805ZM8.55403 13.5805L13.598 9.62738"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Telegram;
